<div  class="col-md-7 col-sm-8 col-xs-3 col-lg-5 galery-selectedPhoto" *ngIf="selectedPhoto">
  <img class="img-fluid" src="{{selectedPhoto}}" alt="" loading="lazy">
</div>
<div class="container" (mouseleave)="removeSelectPhoto()">
  <div class="demo-border">
    <drag-scroll
      class="demo-one"
      drag-scroll-y-disabled="true"
      (reachesLeftBound)="leftBoundStat($event)"
      (reachesRightBound)="rightBoundStat($event)"
      #nav2>
      <img *ngFor="let image of imageList" [title]="image.title" [alt]="image.alt" [src]="image.url"  (click)="clickItem(image.url)" (mouseover)="selectPhoto(image.url)" loading="lazy" drag-scroll-item  />
    </drag-scroll>
  </div>
</div>
